interface BsCoreConfig {
  baseUrl?: string
  authGetToken?: () => Promise<string>
}

let config: BsCoreConfig = {
  baseUrl: undefined,
  authGetToken: undefined,
}

export function setConfig(newConfig: Partial<BsCoreConfig>) {
  config = { ...config, ...newConfig }
}

export function getConfig(): BsCoreConfig {
  return config
}

export function setBaseUrl(url: string) {
  config.baseUrl = url
}

export function getBaseUrl(): string | undefined {
  return config.baseUrl
}

export function setAuthTokenGetter(fn: () => Promise<string>) {
  config.authGetToken = fn
}

export function getAuthToken(): Promise<string> | undefined {
  return config.authGetToken?.()
}
